import { JSX } from "react";

import { IconProps } from "@/@types/general.ts";

const IconBell = (props: IconProps): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M5.27002 9.74994C5.26878 8.86045 5.4436 7.97951 5.78441 7.1579C6.12522 6.33628 6.62527 5.59025 7.25575 4.9628C7.88623 4.33535 8.63466 3.83889 9.4579 3.50204C10.2811 3.16519 11.1629 2.99461 12.0524 3.00013C15.7639 3.02772 18.7327 6.11275 18.7327 9.83468V10.4999C18.7327 13.8577 19.4352 15.8061 20.0539 16.871C20.1206 16.9848 20.156 17.1142 20.1567 17.246C20.1574 17.3779 20.1234 17.5076 20.0579 17.6221C19.9925 17.7366 19.898 17.8318 19.7841 17.8982C19.6701 17.9645 19.5406 17.9996 19.4088 17.9999H4.5932C4.46131 17.9996 4.33185 17.9645 4.21786 17.8981C4.10388 17.8318 4.00941 17.7366 3.94399 17.622C3.87856 17.5075 3.8445 17.3778 3.84523 17.2459C3.84595 17.114 3.88145 16.9846 3.94814 16.8709C4.5672 15.8059 5.27001 13.8575 5.27001 10.4999L5.27002 9.74994Z"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.00098 18V18.75C9.00098 19.5456 9.31705 20.3087 9.87966 20.8713C10.4423 21.4339 11.2053 21.75 12.001 21.75C12.7966 21.75 13.5597 21.4339 14.1223 20.8713C14.6849 20.3087 15.001 19.5456 15.001 18.75V18"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default IconBell;
